export enum PageStatus {
  PlaidLoading = 'PlaidLoading',
  PlaidModalVisible = 'PlaidModalVisible',
  AccountSelection = 'AccountSelection',
}
